var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalletsign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 6,
    fill: "#4FA564",
    fillOpacity: 0.17
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 9H11C9.89543 9 9 9.89543 9 11C9 12.1046 9.89543 13 11 13H24C24 12.07 24 11.605 23.8978 11.2235C23.6204 10.1883 22.8117 9.37962 21.7765 9.10222C21.395 9 20.93 9 20 9Z",
    stroke: "#4FA564",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11V21C9 23.8284 9 25.2426 9.87868 26.1213C10.7574 27 12.1716 27 15 27H21C23.8284 27 25.2426 27 26.1213 26.1213C27 25.2426 27 23.8284 27 21V19C27 16.1716 27 14.7574 26.1213 13.8787C25.2426 13 23.8284 13 21 13H13",
    stroke: "#4FA564",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27 18H25C24.535 18 24.3025 18 24.1118 18.0511C23.5941 18.1898 23.1898 18.5941 23.0511 19.1118C23 19.3025 23 19.535 23 20C23 20.465 23 20.6975 23.0511 20.8882C23.1898 21.4059 23.5941 21.8102 24.1118 21.9489C24.3025 22 24.535 22 25 22H27",
    stroke: "#4FA564",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletsign);
export default __webpack_public_path__ + "static/media/walletsign.e161292231e1a4c1e47ac7b16a366f44.svg";
export { ForwardRef as ReactComponent };